import { sendEcommerceEvent } from '../../services/analytics.js';
import {
    addReward as apiAddReward,
    list,
    removeReward as apiRemoveReward,
    startHeartbeat,
    update,
} from '../../services/basket-api.js';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default () => ({
    pendingUpdates: {},
    updateTimeouts: {},

    init() {
        startHeartbeat();
    },

    // A basket line's date comes in the hotel's own offset, so its day and time are read as written.
    eventDate(startsAt) {
        if (!startsAt) {
            return '';
        }

        const [year, month, day] = startsAt.slice(0, 10).split('-').map(Number);
        const weekday = new Date(Date.UTC(year, month - 1, day)).getUTCDay();

        return `${DAYS[weekday]} ${day} ${MONTHS[month - 1]} ${year}, ${startsAt.slice(11, 16)}`;
    },

    updateQty(rowId, quantity) {
        if (!this.pendingUpdates[rowId]) {
            this.pendingUpdates[rowId] = 0;
        }

        this.pendingUpdates[rowId] += quantity;

        if (this.updateTimeouts[rowId]) {
            clearTimeout(this.updateTimeouts[rowId]);
        }

        this.updateTimeouts[rowId] = setTimeout(() => {
            const totalQuantityChange = this.pendingUpdates[rowId];

            if (totalQuantityChange !== 0) {
                update(rowId, totalQuantityChange).then((result) => {
                    if (result.ok) {
                        const event = totalQuantityChange < 0 ? 'remove_from_cart' : 'add_to_cart';
                        sendEcommerceEvent(event, this.$store.basket);
                    }
                });
            }

            delete this.pendingUpdates[rowId];
            delete this.updateTimeouts[rowId];
        }, 300);
    },

    removeReward() {
        apiRemoveReward().then((result) => {
            if (result.ok) {
                this.refreshAfterRewardChange();
            }
        });
    },

    addReward() {
        apiAddReward().then((result) => {
            if (result.ok) {
                this.refreshAfterRewardChange();
            }
        });
    },

    refreshAfterRewardChange() {
        if (window.location.pathname.includes('/order/checkout')) {
            window.location.reload();
            return;
        }

        list();
    },
});
